export default "__VITE_ASSET__DfsJL1Eb__"